import { useEffect, useState } from "react";
import Iframe from "./Iframe";
import { useSearchParams } from "react-router-dom";

function After() {
  const [searchParams] = useSearchParams();
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timer = setInterval(() => {
      setShow(false);
      setTimeout(() => setShow(true), 200);
    }, parseInt(searchParams.get("second") ?? "10") * 1000 * 6 * 5);
    return () => {
      clearInterval(timer);
    };
  }, [searchParams]);
  return show ? (
    <Iframe src="https://docs.google.com/presentation/d/e/2PACX-1vTZ9tiyB4WTVpakng9f_QIfieanDNgYi5LkPI4IsfP1dtQwXyUK7KJ3vIL_RafKnFvmKpVyKPjhjW1L/embed" />
  ) : null;
}

export default After;
